import { assign, createMachine } from "xstate";
import { IInfoResponse, info } from "@nju/data-access-portal-user";

interface IContext {
  clientData: IInfoResponse;
}

type IEvent =
  | { type: "FETCH_CLIENT" }
  | { type: "FETCH_CLIENT_SUCCESS"; clientData: IInfoResponse }
  | { type: "FETCH_CLIENT_ERROR" };

export const clientProviderMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "loading",
    states: {
      loading: {
        invoke: {
          src: "fetchClient",
        },
        on: {
          FETCH_CLIENT_SUCCESS: {
            actions: "setClientData",
            target: "ready",
          },
          FETCH_CLIENT_ERROR: {
            target: "error",
          },
        },
      },
      error: {
        type: "final",
      },
      ready: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setClientData: assign((context, event) => {
        if (event.type === "FETCH_CLIENT_SUCCESS") {
          return {
            clientData: event.clientData,
          };
        }

        return context;
      }),
    },
    services: {
      fetchClient: () => {
        return async (callback) => {
          try {
            const clientData = (await info()).unwrap();

            callback({ type: "FETCH_CLIENT_SUCCESS", clientData });
          } catch {
            callback({ type: "FETCH_CLIENT_ERROR" });
          }
        };
      },
    },
  },
);
